import {
	SainAction,
	useSAINUsageCriteriaMet,
} from '../../common/controller/analytics/hooks/use-sain-usage';
import { useAnalytics } from '../../common/controller/analytics/use-analytics';
import { FEEDBACK_ENTRYPOINT_ID_SAIN } from '../../constants';
import { useAIAnswerContext } from '../ai-answer-context';
import { onDislikeButtonClick, onLikeButtonClick } from '../analytics';

export function useSmartAnswerCardFeedbackOptions() {
	const { commonAttributes, readingAidsOptions, updateContextCache, userDetails } =
		useAIAnswerContext();
	const { query, errorState, searchSessionId, source, queryHash, cloudId, answerString } =
		commonAttributes;

	const [fireAnalyticsEvent] = useAnalytics();
	const { fireSAINUsageEvent } = useSAINUsageCriteriaMet();

	const onLikeButtonClickHandler = () => {
		updateContextCache({ collapsed: false, liked: true });
		fireAnalyticsEvent(onLikeButtonClick(commonAttributes));
		fireSAINUsageEvent({
			metCriteria: SainAction.POSITIVE_FEEDBACK_PROVIDED,
			commonAttributes,
		});
	};

	const onDislikeButtonClickHandler = () => {
		updateContextCache({ collapsed: false, liked: false });
		fireAnalyticsEvent(onDislikeButtonClick(commonAttributes));
		fireSAINUsageEvent({
			metCriteria: SainAction.NEGATIVE_FEEDBACK_PROVIDED,
			commonAttributes,
		});
	};

	const feedbackAttributes = {
		searchSessionId: searchSessionId,
		source: source,
		queryHash: queryHash,
		cloudId: cloudId,
		documentId: readingAidsOptions?.contentARI,
		errorState: errorState,
	};
	const feedbackAttributesWithConsent = {
		prompt: query,
		answer: answerString,
	};
	const feedbackOptions = {
		attributes: feedbackAttributes,
		attributesWithConsent: feedbackAttributesWithConsent,
		entrypointId: FEEDBACK_ENTRYPOINT_ID_SAIN,
		onLikeButtonClickHandler: onLikeButtonClickHandler,
		onDislikeButtonClickHandler: onDislikeButtonClickHandler,
		userDetails,
	};

	return feedbackOptions;
}
